const clientId = "377b4293e2cb4774a80598e249f9c2f4";
const redirectUri = "https://jamlite.andresnicolas.com/";
const scopes = [
  "playlist-modify-public",
  "playlist-modify-private",
  "user-read-private",
  "user-read-email",
  "playlist-read-private",
  "playlist-read-collaborative",
  "user-library-read",
  "user-top-read",
];

const generateCodeVerifier = () => {
  const array = new Uint8Array(64);
  window.crypto.getRandomValues(array);
  return btoa(String.fromCharCode(...array))
    .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

const generateCodeChallenge = async (verifier) => {
  const data = new TextEncoder().encode(verifier);
  const digest = await window.crypto.subtle.digest("SHA-256", data);
  return btoa(String.fromCharCode(...new Uint8Array(digest)))
    .replace(/\+/g, "-").replace(/\//g, "_").replace(/=+$/, "");
};

export const redirectToSpotifyLogin = async () => {
  [
    "spotify_token",
    "spotify_refresh_token",
    "spotify_token_expires_at",
    "currentStep",
    "selectedTracks",
  ].forEach(k => localStorage.removeItem(k));

  const verifier = generateCodeVerifier();
  const challenge = await generateCodeChallenge(verifier);
  localStorage.setItem("pkce_verifier", verifier);
  const params = new URLSearchParams({
    client_id: clientId,
    response_type: "code",
    redirect_uri: redirectUri,
    scope: scopes.join(" "),
    code_challenge_method: "S256",
    code_challenge: challenge,
  });
  window.location.href = `https://accounts.spotify.com/authorize?${params.toString()}`;
};

const saveTokenData = (data) => {
  const expiresAt = Date.now() + data.expires_in * 1000;
  localStorage.setItem("spotify_token", data.access_token);
  localStorage.setItem("spotify_token_expires_at", expiresAt.toString());
  if (data.refresh_token) localStorage.setItem("spotify_refresh_token", data.refresh_token);
};

export const exchangeCodeForToken = async (code) => {
  const verifier = localStorage.getItem("pkce_verifier");
  if (!verifier) throw new Error("No PKCE verifier found");
  const body = new URLSearchParams({
    client_id: clientId,
    grant_type: "authorization_code",
    code,
    redirect_uri: redirectUri,
    code_verifier: verifier,
  });
  const response = await fetch("https://accounts.spotify.com/api/token", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: body.toString(),
  });
  if (!response.ok) {
    const err = await response.json();
    throw new Error(err.error_description || "Failed to exchange token");
  }
  const data = await response.json();
  localStorage.removeItem("pkce_verifier");
  saveTokenData(data);
  return data;
};

export const refreshAccessToken = async () => {
  const refreshToken = localStorage.getItem("spotify_refresh_token");
  if (!refreshToken) throw new Error("No refresh token available");
  const body = new URLSearchParams({
    client_id: clientId,
    grant_type: "refresh_token",
    refresh_token: refreshToken,
  });
  const response = await fetch("https://accounts.spotify.com/api/token", {
    method: "POST",
    headers: { "Content-Type": "application/x-www-form-urlencoded" },
    body: body.toString(),
  });
  if (!response.ok) {
    ["spotify_token", "spotify_refresh_token", "spotify_token_expires_at"].forEach(k => localStorage.removeItem(k));
    throw new Error("Failed to refresh token");
  }
  const data = await response.json();
  saveTokenData(data);
  return data.access_token;
};

export const isTokenExpired = () => {
  const expiresAt = localStorage.getItem("spotify_token_expires_at");
  if (!expiresAt) return true;
  return Date.now() > parseInt(expiresAt) - 60000;
};

export const getValidToken = async () => {
  if (isTokenExpired()) return await refreshAccessToken();
  return localStorage.getItem("spotify_token");
};